import React, { useState } from 'react';
import { Linkedin, Mail, X } from 'lucide-react';
import { SOLVRAYS_LOGO, COMPANY } from '../../lib/constant';
import Terms from './terms-of-use';
import Solvrays_logo from '../../images/solvrays-bw_y8jyos.svg';

const TermsModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-0 flex justify-center items-center z-50" style={{ margin: '50px'}}>
      <div className="bg-gray-800 p-12 rounded-lg shadow-lg w-full h-full max-w-none relative text-white overflow-auto" style={{ padding: '50px'}}>
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
          onClick={onClose}
        >
          <X size={24} />
        </button>
        <div className="text-sm">
          <Terms />
        </div>
      </div>
    </div>
  );
};
const Footer: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Main Footer */}
      <footer className="relative py-12 bg-gray-900/50 backdrop-blur-sm border-t border-gray-800 overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'url(https://res.cloudinary.com/dqql2wlbt/image/upload/v1738642541/a6fddac0-5be8-422b-a5cd-b9e0d4cc6961.png?q_auto)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'grayscale(100%)',
            mixBlendMode: 'overlay'
          }}
        />

        {/* Content */}
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 md:gap-12">
            {/* Left Column - Logo */}
            <div className="flex flex-col items-center md:items-start gap-4">
              <img 
                src={Solvrays_logo} 
                alt={COMPANY.NAME}
                className="h-16 w-auto"
              />
              <div className="flex gap-4 items-center">
                <a 
                  href="https://www.linkedin.com/company/solvrays"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Linkedin size={18} />
                </a>
                <a 
                  href="mailto:contact@solvrays.com"
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2"
                >
                  <Mail size={18} />
                </a>
              </div>
            </div>

            {/* Right Column - Contact */}
            <div className="flex flex-col items-center md:items-end gap-3">
              <div className="flex flex-col items-center md:items-end">
                <p className="text-gray-300 text-sm font-medium">{COMPANY.PHONE.NUMERIC}</p>
                <p className="text-gray-500 text-xs tracking-wide">{COMPANY.PHONE.VANITY}</p>
                <a 
                  href="mailto:contact@solvrays.com"
                  className="text-gray-400 hover:text-white transition-colors text-sm mt-1"
                >
                  contact@solvrays.com
                </a>
              </div>
              
              <p className="text-gray-400 text-xs text-center md:text-right max-w-xs">
                {COMPANY.ADDRESS}
              </p>
              
              <p 
                className="text-gray-400 text-xs text-center md:text-right max-w-xs underline cursor-pointer hover:text-white"
                onClick={() => setIsModalOpen(true)}
              >
                Privacy Policy
              </p>

              <p className="text-gray-500 text-[10px]">
                Copyright {new Date().getFullYear()} {COMPANY.NAME} LLC. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Fullscreen Modal */}
      {isModalOpen && <TermsModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};

export default Footer;
